import React from 'react';
import { Trash2, Minus, Plus, ShoppingBag } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigation } from '../context/NavigationContext';
import { useApp } from '../context/AppContext';
import { Screen } from '../types';
import { Header } from '../components/ui/Header';
import { Button } from '../components/ui/Button';
export function CartScreen() {
  const {
    navigate
  } = useNavigation();
  const {
    cart,
    updateCartQuantity,
    removeFromCart,
    cartTotal
  } = useApp();
  const shipping = cart.length > 0 ? 4500 : 0;
  const total = cartTotal + shipping;
  if (cart.length === 0) {
    return <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} className="min-h-screen bg-gray-50 flex flex-col" data-id="element-240">
        <Header title="My Cart" showBack={false} data-id="element-241" />
        <div className="flex-1 flex flex-col items-center justify-center p-6 text-center" data-id="element-242">
          <div className="w-24 h-24 bg-primary-50 rounded-full flex items-center justify-center mb-6 text-primary" data-id="element-243">
            <ShoppingBag className="w-12 h-12" data-id="element-244" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-245">
            Your cart is empty
          </h2>
          <p className="text-gray-500 mb-8" data-id="element-246">
            Looks like you haven't added anything to your cart yet.
          </p>
          <Button onClick={() => navigate(Screen.HOME)} data-id="element-247">Start Shopping</Button>
        </div>
      </motion.div>;
  }
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="min-h-screen bg-gray-50 pb-32" data-id="element-248">
      <Header title={`My Cart (${cart.length})`} showBack={false} data-id="element-249" />

      <div className="p-4 space-y-4" data-id="element-250">
        {cart.map(item => <div key={item.id} className="bg-white p-3 rounded-2xl shadow-sm border border-gray-50 flex gap-4" data-id="element-251">
            <div className="w-24 h-24 rounded-xl overflow-hidden bg-gray-100 shrink-0" data-id="element-252">
              <img src={item.product.image} alt={item.product.name} className="w-full h-full object-cover" data-id="element-253" />
            </div>
            <div className="flex-1 flex flex-col justify-between py-1" data-id="element-254">
              <div className="flex justify-between items-start gap-2" data-id="element-255">
                <div data-id="element-256">
                  <h3 className="text-sm font-medium text-gray-900 line-clamp-2 mb-1" data-id="element-257">
                    {item.product.name}
                  </h3>
                  <div className="text-xs text-gray-500 flex gap-2" data-id="element-258">
                    {item.selectedColor && <span data-id="element-259">
                        Color:{' '}
                        <span className="w-3 h-3 inline-block rounded-full align-middle border" style={{
                    backgroundColor: item.selectedColor
                  }} data-id="element-260"></span>
                      </span>}
                    {item.selectedSize && <span data-id="element-261">Size: {item.selectedSize}</span>}
                  </div>
                </div>
                <button onClick={() => removeFromCart(item.id)} className="p-1.5 text-gray-400 hover:text-error hover:bg-error/10 rounded-lg transition-colors" data-id="element-262">
                  <Trash2 className="w-4 h-4" data-id="element-263" />
                </button>
              </div>

              <div className="flex justify-between items-center mt-2" data-id="element-264">
                <span className="text-lg font-bold text-primary" data-id="element-265">
                  ₦{item.product.price.toLocaleString()}
                </span>

                <div className="flex items-center bg-gray-50 rounded-lg border border-gray-100 p-0.5" data-id="element-266">
                  <button onClick={() => updateCartQuantity(item.id, item.quantity - 1)} className="w-7 h-7 flex items-center justify-center text-gray-600 hover:bg-white rounded-md transition-colors" data-id="element-267">
                    <Minus className="w-3 h-3" data-id="element-268" />
                  </button>
                  <span className="w-8 text-center text-sm font-medium text-gray-900" data-id="element-269">
                    {item.quantity}
                  </span>
                  <button onClick={() => updateCartQuantity(item.id, item.quantity + 1)} className="w-7 h-7 flex items-center justify-center text-gray-600 hover:bg-white rounded-md transition-colors" data-id="element-270">
                    <Plus className="w-3 h-3" data-id="element-271" />
                  </button>
                </div>
              </div>
            </div>
          </div>)}

        <div className="bg-white p-4 rounded-2xl shadow-sm border border-gray-50 mt-6" data-id="element-272">
          <div className="flex gap-2 mb-4" data-id="element-273">
            <input type="text" placeholder="Enter Promo Code" className="flex-1 bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 text-sm focus:outline-none focus:border-primary" data-id="element-274" />
            <Button variant="secondary" size="sm" className="px-6" data-id="element-275">
              Apply
            </Button>
          </div>

          <div className="space-y-3 text-sm" data-id="element-276">
            <div className="flex justify-between text-gray-600" data-id="element-277">
              <span data-id="element-278">Subtotal</span>
              <span className="font-medium text-gray-900" data-id="element-279">
                ₦{cartTotal.toLocaleString()}
              </span>
            </div>
            <div className="flex justify-between text-gray-600" data-id="element-280">
              <span data-id="element-281">Shipping</span>
              <span className="font-medium text-gray-900" data-id="element-282">
                ₦{shipping.toLocaleString()}
              </span>
            </div>
            <div className="h-px bg-gray-100 my-2" data-id="element-283"></div>
            <div className="flex justify-between text-base font-bold text-gray-900" data-id="element-284">
              <span data-id="element-285">Total</span>
              <span className="text-primary" data-id="element-286">₦{total.toLocaleString()}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="fixed bottom-[70px] left-0 right-0 bg-white border-t border-gray-100 p-4 z-40" data-id="element-287">
        <div className="max-w-md mx-auto" data-id="element-288">
          <Button fullWidth onClick={() => navigate(Screen.CHECKOUT)} data-id="element-289">
            Proceed to Checkout (₦{total.toLocaleString()})
          </Button>
        </div>
      </div>
    </motion.div>;
}